import { useState, useCallback } from 'react';

const useAdvisorLookup = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const lookupAdvisor = useCallback(async (displayId) => {
    if (!displayId) return null;

    setLoading(true);
    setError(null);

    try {
      const params = new URLSearchParams({ display_id: displayId });
      const response = await fetch(`/api/v6/travel_agent/advisors/search?${params.toString()}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });

      if (!response.ok) {
        throw new Error(`Advisor lookup failed: ${response.status}`);
      }

      const json = await response.json();
      const data = json.data || json;

      if (data.found) {
        return {
          found: true,
          advisorName: data.advisor_name,
          advisorEmail: data.advisor_email,
          agencyName: data.agency_name || '',
          consortiumName: data.consortium_name || '',
          displayId: data.display_id,
          travelAdvisorId: data.travel_advisor_id
        };
      }

      return { found: false };
    } catch (err) {
      setError(err.message);
      console.error('Advisor lookup error:', err);
      return { found: false };
    } finally {
      setLoading(false);
    }
  }, []);

  return { lookupAdvisor, loading, error };
};

export default useAdvisorLookup;
